import { Content, RowContainer, RowTitle, TextSmall, TitleText } from './CookieInformation.style';
import { CookieInformationLabels, Disclosure } from '@usercentrics/cmp-browser-sdk';
import { Fragment, FunctionalComponent, h } from 'preact';
import { convertCookieMaxAge, convertDomain } from '../StorageInfo/helpers';
import { memo } from 'preact/compat';
import { useDeviceState } from '../../hooks';
import { useTcfContext } from '../../contexts/TcfContext';

interface DetailedCookieInformationProps extends Disclosure {
  labels: CookieInformationLabels;
  isLast: boolean;
}

const CookieInformation: FunctionalComponent<DetailedCookieInformationProps> = memo(
  ({
    labels,
    identifier = '',
    name = '',
    description = null,
    type,
    maxAgeSeconds,
    cookieRefresh = null,
    domain = null,
    purposes = null,
    isLast,
  }) => {
    const { isMobile } = useDeviceState();
    const { tcfData } = useTcfContext();
    const purposesData: string[] = [];

    if (!!purposes && purposes.length > 0) {
      purposes.forEach((purpose) => {
        purposesData.push(tcfData?.purposes.find((p) => p.id === purpose)?.name || '');
      });
    }

    return (
      <Content isLast={isLast}>
        {(identifier || name) && (
          <TitleText hasDescription={!!description}>{identifier ? `${identifier}` : `${name}`}</TitleText>
        )}
        {description && <TextSmall isDescription>{description}</TextSmall>}

        <RowContainer>
          <RowTitle isMobile={isMobile}>
            <TextSmall>{`${labels.type}:`}</TextSmall>
          </RowTitle>
          <TextSmall>{type}</TextSmall>
        </RowContainer>

        {type.toString() === 'cookie' && (
          <Fragment>
            <RowContainer>
              <RowTitle isMobile={isMobile}>
                <TextSmall>{`${labels.duration}:`}</TextSmall>
              </RowTitle>
              <TextSmall>{convertCookieMaxAge(maxAgeSeconds, labels)}</TextSmall>
            </RowContainer>

            {cookieRefresh !== null && typeof cookieRefresh !== 'undefined' && (
              <RowContainer>
                <RowTitle isMobile={isMobile}>
                  <TextSmall>{`${labels.cookieRefresh}:`}</TextSmall>
                </RowTitle>
                <TextSmall>{cookieRefresh ? labels.yes : labels.no}</TextSmall>
              </RowContainer>
            )}
          </Fragment>
        )}

        {domain && (
          <RowContainer>
            <RowTitle isMobile={isMobile}>
              <TextSmall>{`${labels.domain}:`}</TextSmall>
            </RowTitle>
            <TextSmall>{convertDomain(domain, labels.anyDomain, labels.multipleDomains)}</TextSmall>
          </RowContainer>
        )}

        {!!purposes && purposes.length > 0 && (
          <RowContainer>
            <RowTitle isMobile={isMobile}>
              <TextSmall>{`${labels.purposes}:`}</TextSmall>
            </RowTitle>
            <TextSmall>{purposesData.join('; ')}</TextSmall>
          </RowContainer>
        )}
      </Content>
    );
  },
);

export default CookieInformation;
